/**
 * ****************************************************************************
 * @description     :   Main component for page APP_WorkReport001
 * @created at      :   2025/09/26
 * @created by      :   ANS901 – hainn@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import repository from './repository';

const dataInit = {
    company_cd: '',
    company_name: '',
    supervising_department: '',
    supervising_department_name: '',
    client_cd: '',
    client_nm: '',
    branch_cd: '',
    branch_nm: '',
    sales_rep_person_cd: '',
    sales_rep_person_nm: '',
    working_date_start: '',
    working_date_end: ''
};

export default {
    namespaced: true,
    state: {
        data: { ...dataInit },
        selectOptionKey: ['id', 'content'],
        searchData: [],
        options: {
            pageSize: [
                { code: 10, name: '10件' },
                { code: 50, name: '50件' },
                { code: 100, name: '100件' }
            ]
        },
        paginationData: {
            pageNo: 1,
            pageSize: 10,
            totalRows: 0,
            msgNoData: '該当するデータが存在しません。'
        }
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.paginationData.pageNo = 1;
            state.paginationData.pageSize = 10;
            state.paginationData.totalRows = 0;
            state.paginationData.msgNoData = '該当するデータが存在しません。';
            state.searchData = [];
        },
        setSearchData(state, data) {
            state.searchData = data ?? [];
        },
        setPageNavigation(state, data) {
            state.paginationData.pageNo = parseInt(data.page);
            state.paginationData.pageSize = parseInt(data.pageSize);
            state.paginationData.totalRows = parseInt(data.totalRows);
            state.paginationData.msgNoData = parseInt(data.totalRows) === 0 ? '該当するデータが存在しません。' : '';
        }
    },
    actions: {
        actionSearch(context, request) {
            try {
                repository.search(request.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        const rows = (data?.Data?.data ?? []).map((row) => ({
                            ...row,
                            mode: 1,
                            client_cd: row.client_cd ?? '',
                            client_nm: row.client_nm ?? '',
                            branch_cd: row.branch_cd ?? '',
                            branch_nm: row.branch_nm ?? '',
                            reporting_date: row.report_date ?? '',
                            client_contract: row.trading_target_responsible ?? '',
                            sales_person: row.sales_responsible ?? '',
                            sales_note: row.sales_considerations ?? row.sales_note ?? ''
                        }));

                        context.commit('setSearchData', rows);
                        context.commit('setPageNavigation', data?.Data?.paging ?? { page: 1, pageSize: 10, totalRows: 0 });
                        if (request.callback) {
                            request.callback(data);
                        }
                    } else if (request.onError) {
                        request.onError({
                            Message: data.Message || data.Data?.message || 'Search failed.'
                        });
                    }
                });
            } catch (e) {
                console.log('Search: ' + e.message);
            }
        }
    }
};
